var ticker = (function() {
"use strict";

	var items = $('.ticker li'),
		interval = 5000,
		fadeSpeed = 800;

	setInterval(function() {

		var active 	= items.filter('.active'),
			next 	= active.next();

		if (next.length === 0) {
			next = items.first();
		}

		active.fadeOut(function(fadeSpeed) {
			active.removeClass('active');

			setTimeout(function() {
				next.fadeIn(function(fadeSpeed) {
					next.addClass('active')
				});
			}, 500);
		});
	}, interval);
})();